export default __webpack_public_path__ + "static/media/CO.0583d4c2.svg";